"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const supportedCryptos = [
    {
        name: "1inch",
        ticker_symbol: "1INCH",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x111111111117dC0aa78b770fA6A738034120C302",
    },
    {
        name: "Aave",
        ticker_symbol: "AAVE",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    },
    {
        name: "Avalanche",
        ticker_symbol: "AVAX-C",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Avalanche C-Chain"],
        contract_address: null,
    },
    {
        name: "Axie Infinity",
        ticker_symbol: "AXS-ERC20",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b",
    },
    {
        name: "Basic Attention Token",
        ticker_symbol: "BAT",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    },
    {
        name: "Binance Coin",
        ticker_symbol: "BNB",
        "memo/tag_field": true,
        tag_type: "memo",
        fixed_min_amount: null,
        networks: ["Binance Chain"],
        contract_address: null,
    },
    {
        name: "Bitcoin",
        ticker_symbol: "BTC",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Bitcoin"],
        contract_address: null,
    },
    {
        name: "Bitcoin Cash",
        ticker_symbol: "BCH",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Bitcoin Cash"],
        contract_address: null,
    },
    {
        name: "Chainlink",
        ticker_symbol: "LINK",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    },
    {
        name: "Chiliz",
        ticker_symbol: "CHZ",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x3506424F91fD33084466F402d5D97f05F8e3b4AF",
    },
    {
        name: "Compound",
        ticker_symbol: "COMP",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
    },
    {
        name: "Cronos",
        ticker_symbol: "CRO-ERC20",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b",
    },
    {
        name: "Dai Stablecoin",
        ticker_symbol: "DAI",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x6b175474e89094c44da98b954eedeac495271d0f",
    },
    {
        name: "Decentraland",
        ticker_symbol: "MANA",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    },
    {
        name: "Dogecoin",
        ticker_symbol: "DOGE",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Dogecoin"],
        contract_address: null,
    },
    {
        name: "Enjin Coin",
        ticker_symbol: "ENJ",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
    },
    {
        name: "Ethereum",
        ticker_symbol: "ETH",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: null,
    },
    {
        name: "Gala",
        ticker_symbol: "GALA",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA",
    },
    {
        name: "Huobi Token",
        ticker_symbol: "HT",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
    },
    {
        name: "KuCoin Token",
        ticker_symbol: "KCS",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xf34960d9d60be18cc1d5afc1a6f012a723a28811",
    },
    {
        name: "Litecoin",
        ticker_symbol: "LTC",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Litecoin"],
        contract_address: null,
    },
    {
        name: "Polkadot",
        ticker_symbol: "DOT",
        "memo/tag_field": false,
        fixed_min_amount: 1,
        networks: ["Polkadot Network"],
        contract_address: null,
    },
    {
        name: "Polygon",
        ticker_symbol: "MATIC",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Polygon"],
        contract_address: "0x0000000000000000000000000000000000001010",
    },
    {
        name: "Quant",
        ticker_symbol: "QNT",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x4a220e6096b25eadb88358cb44068a3248254675",
    },
    {
        name: "Ripple",
        ticker_symbol: "XRP",
        "memo/tag_field": true,
        tag_type: "tag",
        fixed_min_amount: null,
        networks: ["Ripple"],
        contract_address: null,
    },
    {
        name: "Shiba Inu",
        ticker_symbol: "SHIB",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    },
    {
        name: "Stellar",
        ticker_symbol: "XLM",
        "memo/tag_field": true,
        tag_type: "memo",
        fixed_min_amount: null,
        networks: ["Stellar"],
        contract_address: null,
    },
    {
        name: "Sushi",
        ticker_symbol: "SUSHI",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
    },
    {
        name: "Tether USD",
        ticker_symbol: "USDT",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    },
    {
        name: "The Sandbox",
        ticker_symbol: "SAND",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
    },
    {
        name: "Uniswap",
        ticker_symbol: "UNI",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    },
    {
        name: "USD Coin",
        ticker_symbol: "USDC",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    },
    {
        name: "Verse",
        ticker_symbol: "VERSE-ERC20",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x249cA82617eC3DfB2589c4c17ab7EC9765350a18",
    },
    {
        name: "Wrapped Bitcoin",
        ticker_symbol: "WBTC",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    },
    {
        name: "XYO Network",
        ticker_symbol: "XYO",
        "memo/tag_field": false,
        fixed_min_amount: null,
        networks: ["Ethereum"],
        contract_address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
    },
];
exports.default = supportedCryptos;
//# sourceMappingURL=cryptos.js.map